import React from 'react';

import VacancyTeaser from './Teaser';
import VacancyDetail from './Detail';

const NodeVacancy = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <VacancyTeaser {...props} />;
  }

  return <VacancyDetail {...props} />;
};

export default NodeVacancy;
